module.exports = __webpack_public_path__ + "img/gywm-1.4870f0ca.jpg";